import React, { useEffect, useState } from "react";
import Tableoutgoing,{NumberCell}  from "./Tableoutgoing"; // new
import { getAuthorization } from "../../../../axios/AxiosAut";

function Outgoingdata() {

  const [Data, setData] = useState([]);
  const getTableData = () => {
    getAuthorization()
      .get(`dashboard/goods_inout/get_outgoing_deliveries/`)
      .then((res) => {
        console.log("tabel data", res.data
        );
        setData(res.data
          ); 
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  useEffect(() => {
    getTableData();
    console.log("Data.....", Data);
  }, []);

  const data = [
    {
      id:"1",
      tid: "#1345cdvbd",
      customer: "Dutch Grown",
      barcode: "10254354545",
    },
    {
      id:"2",

      tid: "#23232cbedf",
      customer: "Cambo",
      barcode: "10254354545",
    },
    {
      id:"3",

      tid: "#334434erer",
      customer: "Avon Bulbs",
      barcode: "10254354545",
    },
    {
      id:"4",

      tid: "#43454fcedfd",
      customer: "Broardleight Bulbs",
      barcode: "10254354545",
    },
    {
      id:"5",

      tid: "#1345cdvbd",
      customer: "Dutch Grown",
      barcode: "10254354545",
    },
    {
      id:"6",

      tid: "#23232cbedf",
      customer: "Cambo",
      barcode: "10254354545",
    },
    {
      id:"7",

      tid: "#334434erer",
      customer: "Avon Bulbs",
      barcode: "10254354545",
    },
    {
      id:"8",

      tid: "#43454fcedfd",
      customer: "Broardleight Bulbs",
      barcode: "10254354545",
    },
    {
      id:"9",

      tid: "#1345cdvbd",
      customer: "Dutch Grown",
      barcode: "10254354545",
    },
   
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "",
        accessor: "id",
        Cell:NumberCell,
      },
      {
        Header: "Tracking ID",
        accessor: "tid",
      },
      {
        Header: "Customers",
        accessor: "customer",
      },
      {
        Header: "Barcode",
        accessor: "barcode",
      },
      {
        Header: "Date Ordered",
        accessor: "dateorder",
        Cell: (value) => (
          <div className="flex flex-wrap">
            <div className=" text-gray-900 py-4 font-medium ">
             {" "}
             <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M14.1667 14.1667H11.3333V11.3333H14.1667V14.1667ZM9.91667 7.08333H7.08333V9.91667H9.91667V7.08333ZM14.1667 7.08333H11.3333V9.91667H14.1667V7.08333ZM5.66667 11.3333H2.83333V14.1667H5.66667V11.3333ZM9.91667 11.3333H7.08333V14.1667H9.91667V11.3333ZM5.66667 7.08333H2.83333V9.91667H5.66667V7.08333ZM17 1.41667V17H0V1.41667H2.125V2.125C2.125 2.90629 2.76037 3.54167 3.54167 3.54167C4.32296 3.54167 4.95833 2.90629 4.95833 2.125V1.41667H12.0417V2.125C12.0417 2.90629 12.677 3.54167 13.4583 3.54167C14.2396 3.54167 14.875 2.90629 14.875 2.125V1.41667H17ZM15.5833 5.66667H1.41667V15.5833H15.5833V5.66667ZM14.1667 0.708333C14.1667 0.317333 13.85 0 13.4583 0C13.0666 0 12.75 0.317333 12.75 0.708333V2.125C12.75 2.516 13.0666 2.83333 13.4583 2.83333C13.85 2.83333 14.1667 2.516 14.1667 2.125V0.708333ZM4.25 2.125C4.25 2.516 3.93337 2.83333 3.54167 2.83333C3.14996 2.83333 2.83333 2.516 2.83333 2.125V0.708333C2.83333 0.317333 3.14996 0 3.54167 0C3.93337 0 4.25 0.317333 4.25 0.708333V2.125Z" fill="black" fill-opacity="0.7"/>
             </svg>
            </div>
            <div className="mt-3 ml-2 text-gray-400 font-medium">
            21-oct-2021
            </div>
          </div>
        ),
       
      },
      {
        Header: "Date Dispatch",
        accessor: "datedispatch",
        id: "edit",
        Cell: (value) => (
          <div className="flex flex-wrap">
            <div className=" text-gray-900 py-4 font-medium ">
             {" "}
             <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M14.1667 14.1667H11.3333V11.3333H14.1667V14.1667ZM9.91667 7.08333H7.08333V9.91667H9.91667V7.08333ZM14.1667 7.08333H11.3333V9.91667H14.1667V7.08333ZM5.66667 11.3333H2.83333V14.1667H5.66667V11.3333ZM9.91667 11.3333H7.08333V14.1667H9.91667V11.3333ZM5.66667 7.08333H2.83333V9.91667H5.66667V7.08333ZM17 1.41667V17H0V1.41667H2.125V2.125C2.125 2.90629 2.76037 3.54167 3.54167 3.54167C4.32296 3.54167 4.95833 2.90629 4.95833 2.125V1.41667H12.0417V2.125C12.0417 2.90629 12.677 3.54167 13.4583 3.54167C14.2396 3.54167 14.875 2.90629 14.875 2.125V1.41667H17ZM15.5833 5.66667H1.41667V15.5833H15.5833V5.66667ZM14.1667 0.708333C14.1667 0.317333 13.85 0 13.4583 0C13.0666 0 12.75 0.317333 12.75 0.708333V2.125C12.75 2.516 13.0666 2.83333 13.4583 2.83333C13.85 2.83333 14.1667 2.516 14.1667 2.125V0.708333ZM4.25 2.125C4.25 2.516 3.93337 2.83333 3.54167 2.83333C3.14996 2.83333 2.83333 2.516 2.83333 2.125V0.708333C2.83333 0.317333 3.14996 0 3.54167 0C3.93337 0 4.25 0.317333 4.25 0.708333V2.125Z" fill="black" fill-opacity="0.7"/>
             </svg>
            </div>
            <div className="mt-3 ml-2 text-gray-400 font-medium">
            21-oct-2021
            </div>
          </div>
        ),
        // Cell: (value) => (
        //   <button className="float-right"
        //   >
        //     <svg
        //       width="24"
        //       height="25"
        //       viewBox="0 0 24 25"
        //       fill="none"
        //       xmlns="http://www.w3.org/2000/svg"
        //     >
        //       <path
        //         d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
        //         fill="#1F78B4"
        //       />
        //     </svg>
        //   </button>
        // ),
       
      },
      {
        Header: "",
        accessor: "dispatch",
        id: "edit1",
        Cell: (value) => (
          <div>
         

          <button className="float-right mt-3"
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
                fill="#1F78B4"
              />
            </svg>
          </button>
          </div>
        ),
        // Cell: (value) => (
        //   <button className="float-right"
        //   >
        //     <svg
        //       width="24"
        //       height="25"
        //       viewBox="0 0 24 25"
        //       fill="none"
        //       xmlns="http://www.w3.org/2000/svg"
        //     >
        //       <path
        //         d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
        //         fill="#1F78B4"
        //       />
        //     </svg>
        //   </button>
        // ),
       
      },
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <Tableoutgoing
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default Outgoingdata;
